export const DocValidationFileMaxSize = 20000000; // 20 MB

export let DocumentalValidationErrorCode = /*#__PURE__*/function (DocumentalValidationErrorCode) {
  DocumentalValidationErrorCode["GET_GENERIC"] = "GET_GENERIC";
  DocumentalValidationErrorCode["NO_OPTION_SELECTED"] = "NO_OPTION_SELECTED";
  DocumentalValidationErrorCode["NO_ACCEPTED_FILE"] = "NO_ACCEPTED_FILE";
  DocumentalValidationErrorCode["REJECTED_FILE"] = "REJECTED_FILE";
  DocumentalValidationErrorCode["LOW_FILE_QUALITY"] = "LOW_IMAGE_QUALITY";
  DocumentalValidationErrorCode["DOCUMENT_EDM_ERROR"] = "DOCUMENT_EDM_ERROR";
  DocumentalValidationErrorCode["UPLOADING_ERROR"] = "UPLOADING_ERROR";
  return DocumentalValidationErrorCode;
}({});
export const allowedMimeTypes = ['image/jpeg', 'image/jpg', 'image/png',
// 'image/tiff',
'application/pdf'];